import { useEffect, useState } from "react";

export default function useDebounce(values, delay) {
	const [debouncedValues, setDebouncedValues] = useState(values);

	useEffect(
		() => {
			const handler = setTimeout(() => {
				setDebouncedValues(values);
			}, delay);

			return () => {
				clearTimeout(handler);
			};
		},
		// eslint-disable-next-line
    [...values, delay],
	);

	return debouncedValues;
}
